import mfis5 from './mfis_5.json'
import mfis21 from './mfis_21.json'
import msis29 from './msis29.json'
import bdi from './bdi.json'
import fesi from './fesi.json'
import msws12 from './msws_12.json'
import msqol64male from './msqol54_moski.json'
import msqol64female from './msqol54_zenski.json'
import tsqm from './tsqm.json'

function validatePro (pro) {
  return true
}

export const pros = [
  bdi,
  fesi,
  mfis5,
  mfis21,
  msis29,
  msqol64female,
  msqol64male,
  msws12,
  tsqm
]

export function getPro (proId) {
  let pro = null

  pros.forEach(value => {
    if (value.id === proId) {
      pro = value
    }
  })

  if (pro === null) {
    throw new Error(`PRO with ID ${proId} not found.`)
  }

  if (!validatePro(pro)) {
    throw new Error('Invalid PRO JSON')
  }

  pro.questionGroups = pro.questionGroups.map(questionGroup => {
    questionGroup.questions = questionGroup.questions.map(question => {
      question.selectedAnswer = null
      question.hasErrors = false
      question.getSelectedAnswer = function () {
        let selectedAnswer = null
        question.answers.forEach(answer => {
          if (answer.id === question.selectedAnswer) {
            selectedAnswer = answer
          }
        })
        return selectedAnswer
      }
      question.answers = question.answers.map(answer => {
        answer.selected = false
        return answer
      })
      return question
    })
    return questionGroup
  })
  return pro
}



// WEBPACK FOOTER //
// ./src/assets/pros/pros.js